export const ROUTES = {
  home: '/',
  diagnostic: '/diagnostic',
  diagnosticResultat: '/diagnostic/resultat',

  // 9 univers d'audience
  particuliers: '/particuliers',
  professionnels: '/professionnels',
  entreprises: '/entreprises',
  tertiaire: '/tertiaire',
  industrie: '/industrie',
  collectivites: '/collectivites',
  coproprietes: '/coproprietes',
  artisans: '/artisans',
  agriculteurs: '/agriculteurs',

  // Hub outils
  outils: '/outils',
  calculerMesAides: '/calculer-mes-aides',

  // Outils transverses (par pôle)
  cee: '/cee',
  ceeFiches: '/cee/fiches',
  ceeFiche: (code: string) => `/cee/fiches/${code}`,
  comparateur: '/comparateur',
  comparateurDemarrer: '/comparateur/demarrer',
  comparateurReprendre: (token: string) => `/comparateur/reprendre/${token}`,
  renovation: '/renovation',
  decretTertiaire: '/decret-tertiaire',
  secteurs: '/secteurs',
  secteur: (slug: string) => `/secteurs/${slug}`,

  // Espace artisan connecté (Phase 3)
  artisanLogin: '/artisans/connexion',
  artisanDashboard: '/artisans/espace',

  // Contenu & cas
  casClients: '/cas-clients',
  casClient: (slug: string) => `/cas-clients/${slug}`,
  blog: '/blog',
  article: (slug: string) => `/blog/${slug}`,

  // Institutionnel
  aPropos: '/a-propos',
  contact: '/contact',
  devenirPartenaire: '/devenir-partenaire',
  partenaireCandidater: '/devenir-partenaire/candidater',
  legal: {
    mentions: '/legal/mentions-legales',
    confidentialite: '/legal/politique-confidentialite',
    cgv: '/legal/cgv-courtier-energie',
    cookies: '/legal/cookies',
    accessibilite: '/legal/accessibilite',
  },
  admin: '/admin',
} as const;

export const PUBLIC_ROUTES = [
  ROUTES.home,
  ROUTES.outils,
  ROUTES.calculerMesAides,
  ROUTES.diagnostic,
  ROUTES.particuliers,
  ROUTES.professionnels,
  ROUTES.entreprises,
  ROUTES.tertiaire,
  ROUTES.industrie,
  ROUTES.collectivites,
  ROUTES.coproprietes,
  ROUTES.artisans,
  ROUTES.agriculteurs,
  ROUTES.cee,
  ROUTES.ceeFiches,
  ROUTES.comparateur,
  ROUTES.comparateurDemarrer,
  ROUTES.renovation,
  ROUTES.decretTertiaire,
  ROUTES.secteurs,
  ROUTES.casClients,
  ROUTES.blog,
  ROUTES.aPropos,
  ROUTES.contact,
  ROUTES.devenirPartenaire,
  ROUTES.partenaireCandidater,
  ROUTES.legal.mentions,
  ROUTES.legal.confidentialite,
  ROUTES.legal.cgv,
  ROUTES.legal.cookies,
  ROUTES.legal.accessibilite,
] as const;
